import { DashboardUnavailable } from './DashboardUnavailable';
import { RecentActivity } from './RecentActivity';
import { KeyMetrics } from './KeyMetrics';
import { WelcomeHeader } from './WelcomeHeader';
import { useDashboard } from '../hooks/useDashboard';

export function InvestmentsSection() {
  const { data: dashboardData, isLoading, error, refetch } = useDashboard();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span>Loading dashboard...</span>
        </div>
      </div>
    );
  }

  if (error || !dashboardData) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <p className="text-red-600">
            {error instanceof Error
              ? error.message
              : 'Failed to load dashboard'}
          </p>
          <button
            onClick={() => refetch()}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!dashboardData.summary.dashboard_published) {
    return (
      <DashboardUnavailable firstName={dashboardData.contact.first_name} />
    );
  }

  return (
    <div className="space-y-6">
      <WelcomeHeader data={dashboardData} />

      {dashboardData.summary.holdings_published && (
        <KeyMetrics summary={dashboardData.summary} />
      )}

      <RecentActivity />
    </div>
  );
}
